/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Pickup_DescInputs */

const vi_qr_pickup_desc = /** @type {(inputs: Qr_Pickup_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét mã QR trên phiếu xuất kho để nhận đơn hàng`)
};

/**

* @param {Qr_Pickup_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_pickup_desc = /** @type {((inputs?: Qr_Pickup_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Pickup_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_pickup_desc(inputs)
});